/*
¡¡¡¡¡¡¡¡ La respuesta de la api es distinta a la de la web !!!!!!
La respuesta de la api sería:
{
  "status": 400,
  "error": {
    "type": "model_errors",
    "message": "Color formato de color hexadecimal incorrecto. Nombre no puede estar en blanco. Tipo no puede estar en blanco"
  },
  "data": {
    "model": "Cuadernos::Pestana",
    "errors": {
      "color": [
        "formato de color hexadecimal incorrecto"
      ],
      "nombre": [
        "no puede estar en blanco"
      ],
      "tipo": [
        "no puede estar en blanco"
      ]
    },
    "full_messages": [
      "Color formato de color hexadecimal incorrecto",
      "Nombre no puede estar en blanco",
      "Tipo no puede estar en blanco"
    ]
  }
}
*/

const DEFAULTS = {
  error: {
    type: 'standard',
    message: '',
  },
};

export default class RespuestaErrorApi {
  constructor(responseData) {
    this.json = Object.assign(DEFAULTS, responseData || {});
    this.tipo = this.json.error.type;
  }

  getTipo() {
    return this.tipo;
  }

  getMensajeErrorGeneral() {
    return this.json.error.message;
  }

  isModelErrors() {
    return this.tipo === 'model_errors';
  }

  // Objetos con la información de los errores, el campo, mensaje etc
  getModelErrors() {
    return this.json.data?.errors || {};
  }

  // Mensajes de texto completos de los errores
  getMensajesError() {
    if (this.isModelErrors()) {
      return this.json.data?.full_messages || [];
    }

    return [this.getMensajeErrorGeneral()];
  }
}

export function getModelErrors(responseData) {
  return new RespuestaErrorApi(responseData).getModelErrors();
}
